import * as React from 'react';

export const RequestContext = React.createContext({});
